import { render, staticRenderFns } from "./email-setup.vue?vue&type=template&id=372421e2&scoped=true&"
import script from "./email-setup.vue?vue&type=script&lang=js&"
export * from "./email-setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372421e2",
  null
  
)

export default component.exports